import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as PublicStore from '../../../app/store/PublicStore';
import Auth from '../../../youwell-common/Auth';
import { hasValue } from '../../../youwell-common/objectUtils';

class LoadProgram extends React.Component {
    componentDidMount() {
        if (!this.props.currentProgram) {
            this.props.getElement(this.props.programId, { isPage: this.props.isPage });
        }
        if (Auth.isUserAuthenticated() && !this.props.hasSessionData) {
            this.props.getSession(this.props.programId);
        }
        this.props.setCurrentProgram(this.props.programId);
    }

    render() {
        return null;
    }
}

LoadProgram.propTypes = {
    getElement: PropTypes.func.isRequired,
    getSession: PropTypes.func.isRequired,
    setCurrentProgram: PropTypes.func.isRequired,
    currentProgram: PropTypes.object,
    hasSessionData: PropTypes.bool.isRequired,
    programId: PropTypes.string.isRequired,
    isPage: PropTypes.bool.isRequired,
};

LoadProgram.defaultProps = {
    currentProgram: null,
};

const mapStateToProps = (state, ownProps) => {
    const programId = ownProps.programId || ownProps.match?.params.programId;
    const isPage = ownProps.isPage || hasValue(ownProps.match?.params.programId);

    return {
        programId,
        isPage,
        currentProgram: state.publicStore.details && state.publicStore.details[programId],
        hasSessionData: Boolean(state.publicStore.patientId && state.publicStore.progress),
    };
};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(PublicStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadProgram);
